import { isDefined } from '@app/utils/is';
import { Tables } from '@typings';
import cx from 'classnames';
import { WithChildren } from 'react';

import { MarkerCell } from '../Cells/MarkerCell';
import styles from '../Table.module.scss';

export const TableCell = <T,>({
  columnMeta,
  children,
  colSpan,
  isLoading = false,
  rowHeight,
  markerColor,
}: WithChildren<Tables.TableCellProps<T>>) => {
  return (
    <td
      rowSpan={columnMeta?.rowSpan}
      colSpan={colSpan}
      className={cx(styles.tableCell, {
        [styles.notHoverable]: columnMeta?.cellNotHoverable,
        [styles.fullHeight]: columnMeta?.cellFullHeight,
      })}
    >
      <div
        className={cx(styles.tableCellContainer, {
          [styles.collapsible]: columnMeta?.isCollapsible,
        })}
      >
        <div
          className={cx(styles.tableCellInner, {
            [styles.collapsible]: columnMeta?.isCollapsible && !isLoading,
            [styles.fullHeight]: !columnMeta?.isCollapsible,
            [styles.alignCenter]: columnMeta?.align === 'center',
            [styles.alignRight]: columnMeta?.align === 'right',
            [styles.alignLeft]: !isDefined(columnMeta?.align) || columnMeta.align === 'left',
          })}
          style={{ height: rowHeight }}
        >
          {isDefined(markerColor) && <MarkerCell color={markerColor} />}
          {children}
        </div>
      </div>
    </td>
  );
};
